import React, { Component } from 'react';
import { post, handleResponse, defaultHeaders } from '../../utils/network';
import { getCookie, setCookie } from '../../utils/utils';
import { drawerOptions, AllPermissions } from '../../components/common';
import config from '../../utils/config';
import qs from 'qs';

class EntraIdRedirectComponent extends Component {
  constructor(props) {
    super(props);
    const params = qs.parse(props.history.location.search, { ignoreQueryPrefix: true });
    this.state = {
      token: params.token || null
    };
  }

  redirectUser = (userPermissions, featuresPermissions) => {
    const routeOptions = drawerOptions
      .filter(
        op =>
          op.permissionNeeded === 'none' ||
          userPermissions.some(us_p => us_p === AllPermissions.all) ||
          userPermissions.some(us_p => us_p === AllPermissions[op.permissionNeeded]) ||
          featuresPermissions.some(feature_p => feature_p === op.featuresPermissionsNeeded)
      )
      .map(option => ({ path: option.path, value: option.value }));
    setCookie('routeOptions', JSON.stringify(routeOptions));
    // this.props.history.push(routeOptions[0].path);
    this.props.history.push('/search');
  };

  componentDidMount() {
    if (getCookie('isLogged')) {
      this.props.history.push('/search');
    }

    if (this.state.token) {
      console.log("Login succesful, redirecting to sso")
      post('auth/sso', '', false, defaultHeaders, false, this.state.token)
        .then(res => handleResponse(res, this.props))
        .then(data => {
          const name = data.message.firstName ? data.message.firstName + ' ' + data.message.lastName : 'Usuario';
          setCookie('isLogged', true);
          setCookie('userId', data.message.userId);
          setCookie('name', name);
          this.redirectUser(data.message.permissions, data.messsage.featuresPermissions);
        })
        .catch(e => {console.log(e)});
    }else{
      window.location.href = `${config.backEndUrl}entraid/signin`;
    }
  }

  render() {
    return (
      <div style={{height: '100vh', display: 'flex', flexDirection:'column', justifyContent: 'center'}}>
        <h1 style={{textAlign:'center'}}>Accediendo via Entra ID...</h1>
      </div>
    );
  }
}

export default EntraIdRedirectComponent;
